export enum PrivateActivityDocumentsParams {
  activityUuid = "activityUuid",
  activityDocumentUuid = "activityDocumentUuid",
}
